<template>
  <!-- The head of the app-PIN screens as the prototype's gate (D, preview-access.css; 09 §Д-8.3): two orbits in the
       corners, the TACITA wordmark, a lock in a 40 px ring, «С возвращением» and the line under it. -->
  <span class="pin-gate__orbit pin-gate__orbit--one" aria-hidden="true" />
  <span class="pin-gate__orbit pin-gate__orbit--two" aria-hidden="true" />
  <div class="pin-gate__head">
    <div class="pin-gate__wordmark" aria-label="Tacita">TACITA</div>
    <span class="pin-gate__lock" aria-hidden="true"><IconLock :size="21" /></span>
    <p class="pin-gate__title">{{ title }}</p>
    <p class="pin-gate__sub" :class="{ 'pin-gate__sub--error': error }" aria-live="polite">{{ sub }}</p>
  </div>
</template>

<script setup lang="ts">
import { IconLock } from '@/components/ui/icons';

defineProps<{ title: string; sub: string; error?: boolean }>();
</script>

<style scoped lang="scss">
/* Computed from the prototype at 390: orbits 440 / 540 px (#c9a57e16, #b8a99a12, a #8b735512 line, two faint rings);
   the wordmark Garamond 27 / .28em, 64 px above the lock (32 px on a short screen); the title Garamond 38, 18 px under
   the lock and 12 px over the line (13 px, our AA --muted for the prototype's #82725f; the error #984b3e). */
.pin-gate__orbit {
  position: absolute; border-radius: 50%; pointer-events: none; z-index: 0;
  border: 1px solid #8b735512; box-shadow: 0 0 0 32px #8b735505, 0 0 0 33px #8b73550a;
}
.pin-gate__orbit--one { width: 440px; height: 440px; top: -290px; right: -235px; background: #c9a57e16; }
.pin-gate__orbit--two { width: 540px; height: 540px; bottom: -410px; left: -300px; background: #b8a99a12; }
.pin-gate__head { position: relative; z-index: 1; text-align: center; }
.pin-gate__wordmark {
  font-family: var(--font-heading); font-size: 27px; letter-spacing: .28em; padding-left: .28em;
  margin-bottom: 64px; color: var(--text);
  @media (max-height: 700px) { margin-bottom: 32px; }
}
.pin-gate__lock {
  display: inline-grid; place-items: center; width: 40px; height: 40px; border-radius: 50%;
  border: 1px solid #8b735530; color: var(--bronze);
}
.pin-gate__title {
  margin: 18px 0 12px; font-family: var(--font-heading); font-size: 38px; font-weight: 400; line-height: 1.1;
  letter-spacing: -0.015em; color: var(--text);
}
.pin-gate__sub {
  margin: 0; min-height: 20px; font-size: 13px; line-height: 1.5; color: var(--muted);      /* #82725f is under AA here */
  &--error { color: var(--pin-error); }
}
</style>
